export const CLEAR_ALL = 'CLEAR_ALL';

export interface clearAllAction {
    type: typeof CLEAR_ALL
}

export type AllActionsTypes = clearAllAction;